import queryString from 'query-string';
import http from '../httpConfig';
import { List, AddEditApi, ChangePasswordApi } from '../interfaces/user.interface';
import { API_ENDPOINTS } from '../utils/apiConstant';
import { buildPagingResponse } from '../utils/methods';

const list = (payload: List) => {
  const { searchText, role, status, manager, ...others } = payload;
  const paging = buildPagingResponse(others);
  const url = `${API_ENDPOINTS.listUsers}?${queryString.stringify(paging)}`;
  return http.post(url, { search: searchText, role_id: role, manager_id: manager, is_active: status });
};

const managersLookup = (payload: any) => {
  const url = `${API_ENDPOINTS.lookupManagers}?${queryString.stringify({search: payload.searchText, is_active: payload.is_active})}`;
  return http.get(url);
};

const add = (payload: AddEditApi) => {
  return http.post(API_ENDPOINTS.addUser, payload);
};

const edit = (id: string, payload: AddEditApi) => {
  return http.put(`${API_ENDPOINTS.editUser}/${id}`, payload);
};

const changePassword = (payload: ChangePasswordApi) => {
  return http.post(API_ENDPOINTS.changePassword, payload);
};

const get = (id: string) => {
  return http.get(`${API_ENDPOINTS.getUser}/${id}`);
};

const kpis = () => {
  return http.get(API_ENDPOINTS.userListKpis);
};

const lookup = (payload: { searchText: string; exclude?: string; exclude_id?: string; is_active?: string; include?: string; include_id?: string }) => {
  const url = `${API_ENDPOINTS.lookupUsers}?${queryString.stringify({ search: payload.searchText || '', exclude: payload.exclude, exclude_id: payload.exclude_id, is_active: payload.is_active, include: payload.include, include_id: payload.include_id })}`;
  return http.get(url);
};

const assignProperty = (userId: string, propertyIds: string) => {
  return http.post(API_ENDPOINTS.assignRemoveUserProperty, { user_id: userId, property_id: propertyIds });
};

const bulkAssignProperties = (userId: string, propertyIds: string[]) => {
  return http.post(API_ENDPOINTS.bulkAssignUserProperty, { user_id: Number(userId), property_ids: propertyIds.map(Number) });
};

const removeProperty = (id: string) => {
  return http.delete(`${API_ENDPOINTS.assignRemoveUserProperty}/${id}`);
};

const userProperties = (payload: List & { id: string, is_active?: string }) => {
  const { id, is_active, ...others } = payload as any;
  const paging = buildPagingResponse(others);
  const url = `${API_ENDPOINTS.userProperties}?${queryString.stringify({ ...paging, is_active })}`;
  return http.post(url, { user_id: id });
};

const UserService = {
  list,
  managersLookup,
  add,
  edit,
  changePassword,
  get,
  kpis,
  lookup,
  assignProperty,
  bulkAssignProperties,
  removeProperty,
  userProperties
};

export default UserService;
